import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import { env } from "../../env";
import axios from "axios";

const ProfileLayout = ({children, page, customerData, visitTypeData, sendOpenSchedulePopUp, sendPageChange}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showTabList, setShowTabList] = useState(false);

    const openSchedulePopUp  = (e) => {
        sendOpenSchedulePopUp('start');
    };
    const handlePageChange = (e, link) => {
        e.preventDefault();
        sendPageChange(link);
    };
    const handleEndScheduleVisit = async(e) => {
        e.preventDefault();
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(baseUrl+`/api/Customer/EndCustomerVisit`, {
            "CustomerId" : customerData.id,
            "VisitId": visitTypeData.visitId,
            "TypeOfVisit": visitTypeData.visitType,
            "TypeOfVisitId": visitTypeData.visitTypeId
        }, { headers })
        .then((response) => {
            sendOpenSchedulePopUp('end');
        }).catch((error) => {
            console.log(error);
        });
    };

    return (
        <div className="space-y-2 sm:space-y-4">
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="sm:text-2xl font-semibold capitalize">{ t('customer profile') }</h1>
                    {(page === "create-task") &&
                        <div className="text-light-400 text-[10px] w-max sm:w-auto sm:text-sm capitalize flex items-center"><div className="cursor-pointer" onClick={(e) => handlePageChange(e, '/profiles')}>{ t('profile') }</div>/<NavLink to={`/profiles/detail/${customerData.id}`} className="cursor-pointer">{ t('customer detail') }</NavLink>/{ t('create task') }</div>
                    }
                    {(page === "schedule-visit") && 
                        <div className="text-light-400 text-[10px] w-max sm:w-auto sm:text-sm capitalize flex items-center"><div className="cursor-pointer" onClick={(e) => handlePageChange(e, '/profiles')}>{ t('profile') }</div>/<NavLink to={`/profiles/detail/${customerData.id}`} className="cursor-pointer">{ t('customer detail') }</NavLink>/{ t('user appointment') }</div>
                    }   
                    {(page === 'profile') &&
                        <div className="text-light-400 text-xs sm:text-sm capitalize flex items-center"><div className="cursor-pointer" onClick={(e) => handlePageChange(e, '/profiles')}>{ t('profile') }</div>/{ t('customer profile') }</div>
                    }
                </div>
                {(page === 'profile' && customerData.isActive) &&
                    <div className="hidden md:flex space-x-3 text-sm font-medium">
                        <div onClick={(e) => ((visitTypeData && visitTypeData.visitId) ? navigate(`/orders/create/${customerData.id}`) : null)} className={((visitTypeData && visitTypeData.visitId) ? "cursor-pointer text-blue-normal" : "cursor-not-allowed text-gray-dark") + " capitalize"}>create order</div>
                        <div onClick={(e) => ((visitTypeData && visitTypeData.visitId) ? navigate(`/profiles/task/${customerData.id}`) : null)} className={((visitTypeData && visitTypeData.visitId) ? "cursor-pointer text-blue-normal" : "cursor-not-allowed text-gray-dark") + " capitalize"}>create task</div>
                        {/* <div onClick={(e) => ((visitTypeData && visitTypeData.visitId) ? navigate(`/profiles/appointment/${customerData.id}`) : null)} className={((visitTypeData && visitTypeData.visitId) ? "cursor-pointer text-blue-normal" : "cursor-not-allowed text-gray-dark") + " first-letter:capitalize"}>schedule a visit</div> */}
                    </div>
                }
                {customerData.isActive && 
                    <div className="hidden md:flex text-right space-x-2">
                        {(visitTypeData && visitTypeData.visitId) ? 
                            <div className="flex items-center space-x-2">
                                
                                <div onClick={(e) => handleEndScheduleVisit(e)} className="cursor-pointer text-center px-4 text-sm font-medium py-2 text-white bg-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('end') }</div>
                            </div>
                            :
                            <div className={(customerData.isActive ? "cursor-pointer" : "cursor-not-allowed") + " bg-green-light text-green-normal flex items-center px-4 py-2 rounded-lg"} onClick={(e) => (customerData.isActive ? openSchedulePopUp(e) : null)}>
                                <img src="../../assets/icons/profile/play.svg" alt="play" />
                                <span className="capitalize ml-2 font-semibold text-sm">start</span>
                            </div>
                        }
                    </div>
                }
                {customerData.isActive && 
                    <div className="md:hidden flex items-center space-x-2">
                        {(visitTypeData && visitTypeData.visitId) ? 
                            <div className="flex items-center space-x-2">
                                <div onClick={(e) => handleEndScheduleVisit(e)} className="cursor-pointer text-center px-4 text-sm font-medium py-2 text-white bg-blue-normal border border-blue-normal rounded-lg tracking-wide capitalize">{ t('end') }</div>
                            </div>
                            :
                            <div className={(customerData.isActive ? "cursor-pointer" : "cursor-not-allowed") + " bg-green-normal flex items-center p-2.5 rounded-lg"} onClick={(e) => (customerData.isActive ? openSchedulePopUp(e) : null)}>
                                <img src="../../assets/icons/profile/play1.svg" alt="play" />
                            </div>
                        }
                        {(page === "profile") &&
                            <div className="relative flex lg:hidden text-sm font-medium">
                                <img  className="border border-background-normal bg-white p-2 rounded-full shadow-sm" onClick={(e) => setShowTabList(!showTabList)} src="../../../assets/icons/table/vertical-dot.svg" alt="dot"/>
                                {showTabList ?
                                    <ul className="absolute z-30 bg-white shadow-md rounded-md top-10 right-0 w-32">
                                        <li onClick={(e) => ((visitTypeData && visitTypeData.visitId) ? navigate(`/orders/create/${customerData.id}`) : null)} className={((visitTypeData && visitTypeData.visitId) ? "cursor-pointer text-black" : "cursor-not-allowed text-gray-dark") + " capitalize px-2 py-1.5"}>create order</li>
                                        <li onClick={(e) => ((visitTypeData && visitTypeData.visitId) ? navigate(`/profiles/task/${customerData.id}`) : null)} className={((visitTypeData && visitTypeData.visitId) ? "cursor-pointer text-black" : "cursor-not-allowed text-gray-dark") + " capitalize px-2 py-1.5"}>create task</li>
                                        {/* <li onClick={(e) => ((visitTypeData && visitTypeData.visitId) ? navigate(`/profiles/appointment/${customerData.id}`) : null)} className={((visitTypeData && visitTypeData.visitId) ? "cursor-pointer text-black" : "cursor-not-allowed text-gray-dark") + " first-letter:capitalize px-2 py-1.5"}>schedule a visit</li> */}
                                    </ul>
                                : null}
                            </div>
                        }
                    </div>
                }
            </div>
            <div>
                {children}
            </div>
        </div>
    )
}
export default ProfileLayout;